import React, { Component } from 'react';
import { Modal, Steps, Button, message, Select } from 'antd';
const Step = Steps.Step;
const Option = Select.Option;

class CarModal extends Component {
  constructor(props) {
    super(props);
    this.steps = {step0: {plate: false, details: false}, step1: {profile_id: false}};
    this.state = {step: 0, stepLimit: 1, stepValidation: this.steps, car: {}};
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    // Input values
    this.handlePlate = this.handlePlate.bind(this);
    this.handleDetails = this.handleDetails.bind(this);
    this.handleProfile = this.handleProfile.bind(this);
    this.setProp = this.setProp.bind(this);
  }

  handleNext() {
    if(!this.validateStep())
      return message.warning('Necesitas llenar los campos obligatorios')

    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.car);
      this.setState({validation: true, car: {}});
    } else {
      this.setState({step: this.state.step + 1});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.props.handleClose();
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  validateStep() {
    let steps = 0;
    let total = 0;
    for(let item in this.state.stepValidation[`step${this.state.step}`]) {
      if(this.state.stepValidation[`step${this.state.step}`][item]) {
        steps += 1;
      }
      total += 1;
    }
    
    if(steps === total) {
      return true;
    } else {
      return false;
    }
  }

  handlePlate(event) {
    this.setProp('plate', event.target.value);
  }

  handleDetails(event) {
    this.setProp('details', event.target.value);
  }

  handleProfile(value) {
    this.setProp('profile_id', value);
  }

  setProp(prop, value) {
    let car = this.state.car;
    let validation = this.state.stepValidation;
    car[prop] = value;
    
    // Update validation
    if(String(value).length > 0) {
      validation[`step${this.state.step}`][prop] = true;
    } else {
      validation[`step${this.state.step}`][prop] = false;
    }

    this.setState({car: car, stepValidation: validation});
  }

  showStep(step) {
    if(step === this.state.step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    // List profiles
    const profiles = this.props.profiles.map(profile => {
      return (
        <Option value={profile.id} key={profile.id}>{profile.names}</Option>
      );
    });

    // Render component
    return (
      <Modal
        title={this.props.title}
        visible={this.props.visible}
        onCancel={this.props.handleClose}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        <div className="row" style={{ padding: '0px 30px' }}>
          <Steps size="small" current={this.state.step}>
            <Step title="Placas" />
            <Step title="Empleado" />
          </Steps>
        </div>

        <br/> <br/>

        <div className="row" style={{ padding: '0px 30px' }}>
          <div style={{ width: '100%', display: this.showStep(0) }}>
            <div className="form-group">
              <label>Placas</label>
              <input type="text" className="form-control" defaultValue={this.props.current.plate} placeholder="Placas del auto" onChange={this.handlePlate} />
            </div>

            <div className="form-group">
              <label>Detalles</label>
              <input type="text" className="form-control" defaultValue={this.props.current.details} placeholder="Color, marca, modelo" onChange={this.handleDetails} />
            </div>
          </div>
        </div>

        <div className="row" style={{ padding: '0px 30px' }}>
          <div style={{ width: '100%', display: this.showStep(1) }}>
            <div className="form-group">
              <label>Empleado</label>
              <Select
                showSearch
                onChange={this.handleProfile}
                optionFilterProp="children"
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                style={{ width: '100%' }}
              >
                {profiles}
              </Select>
            </div>
          </div>
        </div>

        <br/><hr/>

        <div className="form-group text-center">
          <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
          <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
        </div>
      </Modal>
    );
  }
}

export default CarModal;



// WEBPACK FOOTER //
// ./src/components/modals/CarModal.js